import {Component, OnInit} from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {finalize} from 'rxjs/operators';
import {isArray} from 'rxjs/internal-compatibility';
import {VerityPriceModel} from '../../../utils/models/verity-price-model';
import {AuthService} from '../../../utils/services/auth.service';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material';
import {VeritiyPricesTableRowModel} from '../../models/verity-prices-table-row-model';
import {DefaultExporterComponent} from '../../../utils/components/export/DefaultExporterComponent';
import {PriceChangesService} from '../../services/price-changes.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};


@Component({
  selector: 'app-price-changes',
  templateUrl: './price-changes.component.html',
  styleUrls: ['./price-changes.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ],
})
export class PriceChangesComponent extends DefaultExporterComponent implements OnInit {

  selection = new SelectionModel<VerityPriceModel>(true, []);
  tableColumns: VeritiyPricesTableRowModel[] = [
    new VeritiyPricesTableRowModel(1, 100, 'Country', 'Country_name', true, 'left', true),
    new VeritiyPricesTableRowModel(2, 100, 'Company', 'Manufacturer', true, 'left', true),
    new VeritiyPricesTableRowModel(3, 110, 'Likely Parallel Trade', 'parallel_trade', true, 'left', true),
    new VeritiyPricesTableRowModel(4, 100, 'Brand', 'International_Brand_Name', true, 'left', true),
    new VeritiyPricesTableRowModel(5, 100, 'INN', 'INN', true, 'left', true),
    new VeritiyPricesTableRowModel(6, 100, 'ATC', 'ATC', true, 'left', true),
    new VeritiyPricesTableRowModel(7, 100, 'Strength', 'Strength', true, 'left', true),
    new VeritiyPricesTableRowModel(8, 100, 'Form', 'Form', true, 'left', true),
    new VeritiyPricesTableRowModel(9, 120, 'Pack size', 'Package_size', true, 'center'),
    new VeritiyPricesTableRowModel(10, 120, 'Package', 'Package_type', true, 'left'),
    new VeritiyPricesTableRowModel(11, 120, 'SKU Details', 'SKU_detail', true, 'left'),
    new VeritiyPricesTableRowModel(12, 120, 'Currency', 'Loc_Currency', true, 'left'),
    new VeritiyPricesTableRowModel(13, 150, 'Ex-Factory list price at', 'ExF_excl_VAT_from', true, 'right'),
    new VeritiyPricesTableRowModel(14, 160, 'Ex-Factory list price at', 'ExF_excl_VAT_to', true, 'right'),
    new VeritiyPricesTableRowModel(15, 160, 'Ex-Factory list price Diff', 'ExF_excl_VAT_diff', true, 'right'),
    new VeritiyPricesTableRowModel(16, 120, 'ExFactory list price flag', 'ExF_excl_VAT_flag', true, 'left'),
    new VeritiyPricesTableRowModel(17, 160, 'Wholesale price at', 'WHS_excl_VAT_from', true, 'right'),
    new VeritiyPricesTableRowModel(18, 160, 'Wholesale price at', 'WHS_excl_VAT_to', true, 'right'),
    new VeritiyPricesTableRowModel(19, 160, 'Wholesale price Diff', 'WHS_excl_VAT_diff', true, 'right'),
    new VeritiyPricesTableRowModel(20, 120, 'Wholesale price flag', 'WHS_excl_VAT_flag', true, 'left'),
    new VeritiyPricesTableRowModel(21, 170, 'Pharmacy price without VAT at', 'Ret_excl_VAT_from', true, 'right'),
    new VeritiyPricesTableRowModel(22, 170, 'Pharmacy price without VAT at', 'Ret_excl_VAT_to', true, 'right'),
    new VeritiyPricesTableRowModel(23, 170, 'Pharmacy price without VAT Diff', 'Ret_excl_VAT_diff', true, 'right'),
    new VeritiyPricesTableRowModel(24, 150, 'Pharmacy price without VAT flag', 'Ret_excl_VAT_flag', true, 'left'),
    new VeritiyPricesTableRowModel(25, 150, 'Pharmacy price with VAT at', 'Ret_incl_VAT_from', true, 'right'),
    new VeritiyPricesTableRowModel(26, 150, 'Pharmacy price with VAT at', 'Ret_incl_VAT_to', true, 'right'),
    new VeritiyPricesTableRowModel(27, 150, 'Pharmacy price with VAT Diff', 'Ret_incl_VAT_diff', true, 'right'),
    new VeritiyPricesTableRowModel(28, 150, 'Pharmacy price with VAT flag', 'Ret_incl_VAT_flag', true, 'left'),
    new VeritiyPricesTableRowModel(29, 100, 'SKU_id', 'SKU_id', true, 'left'),
    new VeritiyPricesTableRowModel(30, 100, 'Loc_Product_cd', 'Loc_Product_cd', true, 'left'),
  ];

  public tableInput: VerityPriceModel[] = [];
  public datePickerForm: FormGroup;
  public isLoading: boolean;

  constructor(private authService: AuthService, private fb: FormBuilder, public priceChangesService: PriceChangesService) {
    super();
  }

  ngOnInit() {
    this.datePickerForm = this.fb.group({
      'dateFrom': [this.priceChangesService.dateFrom, Validators.required],
      'dateTo': [this.priceChangesService.dateTo, Validators.required]
    });

    this.datePickerForm.valueChanges.subscribe(changes => {
      if (this.datePickerForm.valid) {
        const dateFrom: Date = this.datePickerForm.controls['dateFrom'].value;
        const dateTo: Date = this.datePickerForm.controls['dateTo'].value;

        this.requestDataForDates(this.extractDateAsString(dateFrom), this.extractDateAsString(dateTo));
      }
    });
  }

  onTableViewChange($event) {
    switch ($event) {
      case 0:
        this.showColumns(['ExF_excl_VAT_from', 'ExF_excl_VAT_to', 'ExF_excl_VAT_flag', 'WHS_excl_VAT_from', 'WHS_excl_VAT_to',
          'WHS_excl_VAT_flag', 'Ret_excl_VAT_from', 'Ret_excl_VAT_to', 'Ret_excl_VAT_flag',
          'Ret_incl_VAT_from', 'Ret_incl_VAT_to', 'Ret_incl_VAT_flag', 'WHS_excl_VAT_diff', 'Ret_excl_VAT_diff', 'Ret_incl_VAT_diff']);
        break;

      case 1:
        this.showColumns(['ExF_excl_VAT_from', 'ExF_excl_VAT_to', 'ExF_excl_VAT_flag']);
        this.hideColumns(['WHS_excl_VAT_from', 'WHS_excl_VAT_to', 'WHS_excl_VAT_diff',
          'WHS_excl_VAT_flag', 'Ret_excl_VAT_from', 'Ret_excl_VAT_to', 'Ret_excl_VAT_diff', 'Ret_excl_VAT_flag',
          'Ret_incl_VAT_from', 'Ret_incl_VAT_to', 'Ret_incl_VAT_diff', 'Ret_incl_VAT_flag']);
        break;
    }
  }


  buildExportData(): any {
    const dataToTransfer = this.generateDataToTransfer();

    return {
      filename: 'export',
      headers: dataToTransfer.visibleKeys,
      module: this.router.url.substring(1),
      data: encodeURIComponent(JSON.stringify(dataToTransfer.dataToTransfer)),
      date_from: this.datePipe.transform(this.datePickerForm.controls.dateFrom.value, 'yyyy-MM-dd'),
      date_to: this.datePipe.transform(this.datePickerForm.controls.dateTo.value, 'yyyy-MM-dd')
    };
  }

  private showColumns(keys: Array<string>) {
    keys.forEach(key => this.changeColumnVisibility(key, true));
  }

  private hideColumns(keys: Array<string>) {
    keys.forEach(key => this.changeColumnVisibility(key, false));
  }

  private changeColumnVisibility(key: string, visible: boolean) {
    const veritiyPricesTableRowModel = this.tableColumns.find(column => column.key === key);
    if (veritiyPricesTableRowModel) {
      veritiyPricesTableRowModel.visible = visible;
    }
  }

  private formatHeaderDateFrom(label: string, key: string) {
    const column = this.tableColumns.find(col => col.key === key);

    column.name = this.formatHeaderWithDate(label, this.datePickerForm.controls['dateFrom'].value);
  }

  private formatHeaderDateTo(label: string, key: string) {
    const column = this.tableColumns.find(col => col.key === key);

    column.name = this.formatHeaderWithDate(label, this.datePickerForm.controls['dateTo'].value);
  }

  private formatHeaderWithDate(label: string, date: Date): string {
    return label + ' ' + this.extractDateAsString(date);
  }

  private extractDateAsString(fromDate: Date) {
    return this.datePipe.transform(fromDate, 'yyyy-MM-dd');
  }

  private requestDataForDates(fromDate: string, toDate: string) {
    this.isLoading = true;

    this.http.post('pricechangeview/', {
      fromdate: fromDate,
      enddate: toDate
    })
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe((response: Array<VerityPriceModel>) => {
        this.initTableColumns();
        this.tableInput = this.calculateDiff(response);
      });
  }

  private calculateDiff(inputData: Array<VerityPriceModel>) {
    const keys = ['ExF_excl_VAT', 'WHS_excl_VAT', 'Ret_excl_VAT', 'Ret_incl_VAT'];

    if (isArray(inputData)) {
      inputData.forEach(row => {
        keys.forEach(key => {
          const fromValue = row[key + '_from'];
          const toValue = row[key + '_to'];

          const fromNumberValue = Number(fromValue);
          const toNumberValue = Number(toValue);

          if (fromNumberValue > toNumberValue) {
            row['background'] = '#ff8077';
          } else if (fromNumberValue < toNumberValue) {
            row['background'] = '#74ff7c';
          }

          if (fromNumberValue > 0 && toNumberValue > 0) {
            row[key + '_diff'] = Number(Math.round(parseFloat(((toNumberValue / fromNumberValue) - 1) * 100 + 'e+2')) + 'e-2');
          } else if (fromNumberValue === 0 && toNumberValue === 0) {
            row[key + '_diff'] = 0;
          } else if (fromNumberValue === 0 && toNumberValue > 0) {
            row[key + '_diff'] = 100;
          } else if (fromNumberValue > 0 && toNumberValue === 0) {
            row[key + '_diff'] = -100;
          }
        });
      });
    }
    return inputData;
  }

  private initTableColumns() {
    this.formatHeaderDateFrom('Ex-Factory list price at', 'ExF_excl_VAT_from');
    this.formatHeaderDateTo('Ex-Factory list price at', 'ExF_excl_VAT_to');

    this.formatHeaderDateFrom('Wholesale price at', 'WHS_excl_VAT_from');
    this.formatHeaderDateTo('Wholesale price at', 'WHS_excl_VAT_to');

    this.formatHeaderDateFrom('Pharmacy price without VAT at', 'Ret_excl_VAT_from');
    this.formatHeaderDateTo('Pharmacy price without VAT at', 'Ret_excl_VAT_to');

    this.formatHeaderDateFrom('Pharmacy price with VAT at', 'Ret_incl_VAT_from');
    this.formatHeaderDateTo('Pharmacy price with VAT at', 'Ret_incl_VAT_to');
  }
}
